import { endpointConstants } from "../constants";
import { get } from "../../utils";

export const yodaAgentService = {
  getAll,
  getOne,
};

function getAll() {
  let endpoint = endpointConstants.YODAAGENT.GET_ALL;
  return get(endpoint, {});
}

function getOne(agentId) {
  let endpoint = endpointConstants.YODAAGENT.GET_ONE.replace(
    ":agentId",
    agentId,
  );
  return get(endpoint, {});
}
